<div class="estimated-price-cntr" *ngIf="configuration?.flow?.TotalAmount > 0; else loadingPrice">
  <span> Totale ordine: {{ configuration.flow.TotalAmount | currency:'EUR':'symbol':'1.0-3' }} </span>
</div>
<ng-template #loadingPrice>
  
  <span> Totale ordine: // </span>

</ng-template>
